import axios from 'axios';
import {
    handle
} from 'redux-pack';
import { authURL, mortgageTerms, mortgageContact, saveCalculatorDraft } from './index';

// Actions
export const MORTGAGE_IS_LOADING = 'MORTGAGE_IS_LOADING';
export const MORTGAGE_HAS_ERROR = 'MORTGAGE_HAS_ERROR';
export const MORTGAGE_UPDATE = 'MORTGAGE_UPDATE';
export const MORTGAGE_FORM_SUBMIT = 'MORTGAGE_FORM_SUBMIT';
export const SET_MORTGAGE_SUBMISSION_ID = 'SET_MORTGAGE_SUBMISSION_ID';

// Default State
const initialState = {
    isLoading: false,
    hasError: false,
    submissionId: null
};

const dummyMortgageRates = [
    { "RateType": "ML", "RateName": "Closed Fixed", "SubType": "Fixed", "Product": "1 Year", "Range": "1 Year", "Rate1": 5.84, "Rate1Disclaimer": null, "AddlInfo": "" },
    { "RateType": "ML", "RateName": "Closed Fixed", "SubType": "Fixed", "Product": "2 Year", "Range": "2 Year", "Rate1": 5.09, "Rate1Disclaimer": null, "AddlInfo": "" },
    { "RateType": "ML", "RateName": "Closed Fixed", "SubType": "Fixed", "Product": "3 Year", "Range": "3 Year", "Rate1": 4.49, "Rate1Disclaimer": null, "AddlInfo": "" },
    { "RateType": "ML", "RateName": "Closed Fixed", "SubType": "Fixed", "Product": "4 Year", "Range": "4 Year", "Rate1": 4.39, "Rate1Disclaimer": null, "AddlInfo": "" },
    { "RateType": "ML", "RateName": "Closed Fixed", "SubType": "Fixed", "Product": "5 Year", "Range": "5 Year", "Rate1": 4.34, "Rate1Disclaimer": null, "AddlInfo": "" },
    { "RateType": "ML", "RateName": "Closed Variable", "SubType": "Variable", "Product": "5 Year", "Range": "5 Year", "Rate1": 4.60, "Rate1Disclaimer": null, "AddlInfo": "" },
];

const useLocalDummyRates = !process.env.REACT_APP_API_HOST;

export const getMortgageTerms = dispatch => () => {
    dispatch({
        type: MORTGAGE_IS_LOADING,
        isLoading: true
    });

    if (useLocalDummyRates) {
        dispatch({
            type: MORTGAGE_HAS_ERROR,
            hasError: false
        });
        dispatch({
            type: MORTGAGE_UPDATE,
            response: {
                terms: [...dummyMortgageRates]
            }
        });
        dispatch({
            type: MORTGAGE_IS_LOADING,
            isLoading: false
        });
        return;
    }

    axios({
        url: authURL,
        method: 'get'
    })
        .then(response => {
            axios({
                url: mortgageTerms,
                method: 'get',
                headers: {
                    'Authorization': `Bearer ${response.data.token}`
                }
            })
                .then(response => {
                    dispatch({
                        type: MORTGAGE_HAS_ERROR,
                        hasError: false
                    });
                    dispatch({
                        type: MORTGAGE_UPDATE,
                        response: {
                            terms: [...response.data]
                        }
                    });
                })
                .catch(() => {
                    dispatch({
                        type: MORTGAGE_HAS_ERROR,
                        hasError: true
                    });
                })
                .then(() => {
                    dispatch({
                        type: MORTGAGE_IS_LOADING,
                        isLoading: false
                    });
                });
        })
        .catch(() => {
            dispatch({
                type: MORTGAGE_HAS_ERROR,
                hasError: true
            });
        })
        .then(() => {
            dispatch({
                type: MORTGAGE_IS_LOADING,
                isLoading: false
            });
        });
};

export const mortgageContactSubmit = (token, data) => ({
    type: MORTGAGE_FORM_SUBMIT,
    promise: axios({
        url: mortgageContact,
        method: 'POST',
        data,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
});

export const mortgageSubmission = (token, data) => {
    const headers = {
        'Content-Type': 'application/json'
    };

    // Only add Authorization header if token is provided
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return {
        type: MORTGAGE_FORM_SUBMIT,
        promise: axios({
            url: saveCalculatorDraft,
            method: 'POST',
            data,
            headers
        })
    };
};

// Action creator for setting submission ID
export const setMortgageSubmissionId = (submissionId) => ({
    type: SET_MORTGAGE_SUBMISSION_ID,
    submissionId
});

export default (state = initialState, action = {}) => {
    const {
        type,
        response,
        isLoading,
        hasError
    } = action;

    switch (type) {
        case MORTGAGE_FORM_SUBMIT:
            return handle(state, action, {
                start: prevState => ({
                    ...prevState,
                    isLoading: true
                }),
                success: (prevState, { payload: token }) => ({
                    ...prevState,
                    token,
                    hasError: false
                }),
                failure: prevState => ({
                    ...prevState,
                    hasError: true
                }),
                finish: prevState => ({
                    ...prevState,
                    isLoading: false
                })
            });
        case MORTGAGE_IS_LOADING:
            return {
                ...state,
                isLoading
            };
        case MORTGAGE_HAS_ERROR:
            return {
                ...state,
                hasError
            };
        case MORTGAGE_UPDATE:
            return {
                ...state,
                ...response
            };
        case SET_MORTGAGE_SUBMISSION_ID:
            return {
                ...state,
                submissionId: action.submissionId
            };
        default:
            return state;
    }
}
